import React, { useEffect, useLayoutEffect, useRef } from 'react';
import Navbar from './navbar';
import { Frame } from '@shopify/polaris';
import Topbar from './topbar';
import { PATHS } from 'src/routes/paths';
import { Box } from '@mui/material';
import { lowerCaseWithoutSpace } from 'src/utils/format_data';
import { APP_NAME } from 'src/config';
import { useLocalStorage } from 'src/hooks/use_local_storage';
import { usePathname } from 'src/hooks/router/use_pathname';
import { useRouter } from 'src/hooks/router/use_router';
import { useUserLanguage } from 'src/hooks/use_user_language';

const logo = {
  topBarSource: `/assets/logo/${lowerCaseWithoutSpace(APP_NAME)}_white.png`,
  width: 32,
  url: PATHS.dashboard.root,
};

export const addEditPadding = {
  px: { xs: 0, md: 5, lg: 10 },
};

export const NAV_WIDTH_OPEN = '15rem';
export const NAV_WIDTH_CLOSED = '60px';

export default function DashboardLayout({ children }) {
  const [navOpen, setNavOpen] = useLocalStorage('nav_open', true);
  const pathName = usePathname();
  const router = useRouter();
  const wasInSettings = useRef(false);

  useUserLanguage();

  useLayoutEffect(() => {
    document.documentElement.style.setProperty(
      '--pg-navigation-width',
      navOpen ? NAV_WIDTH_OPEN : NAV_WIDTH_CLOSED,
    );
  }, [navOpen]);

  useEffect(() => {
    const isInSettings = pathName.startsWith(PATHS.dashboard.settings.root);

    if (wasInSettings.current && !isInSettings && pathName !== PATHS.dashboard.root) {
      router.replace(PATHS.dashboard.root);
    }

    wasInSettings.current = isInSettings;
  }, [pathName, router]);

  return (
    <Frame
      logo={logo}
      topBar={<Topbar />}
      navigation={
        <Navbar
          navOpen={navOpen}
          setNavOpen={setNavOpen}
        />
      }
    >
      <Box sx={{ pb: 5, position: 'relative' }}>{children}</Box>
    </Frame>
  );
}
